import moment from "moment";
import countries from "i18n-iso-countries";
import { Locale, supportedLocales } from "@ct-react/locale";

export const allLocales = [
  ...supportedLocales.filter(l => l.basename !== "en"),
  ...[ { ...supportedLocales.find(l => l.basename === "en"), formatOverriders: { number: "de-CH" } } as Locale ]
];

const importMomentJsLocale = async (locale: Locale) => {
  switch (locale.code.toLowerCase()) {
    case "en-gb":
      // @ts-ignore
      await import("moment/locale/en-gb");
      return "en-gb";
    case "de-ch":
      // @ts-ignore
      await import("moment/locale/de-ch");
      return "de-ch";
    default:
      // @ts-ignore
      await import("moment/locale/fr-ch");
      return "fr-ch";
  }
}

const loadCountryLocale = (locale: Locale) => {
  switch (locale.basename) {
    case "fr":
      return import(/* webpackChunkName: "countries-fr" */ "i18n-iso-countries/langs/fr.json");
    case "en":
      return import(/* webpackChunkName: "countries-en" */ "i18n-iso-countries/langs/en.json");
    case "de":
      return import(/* webpackChunkName: "countries-de" */ "i18n-iso-countries/langs/de.json");
    default:
      throw new Error(`Unsupported country locale: ${locale.basename}`);
  }
};

const loadCountries = async (locale: Locale): Promise<void> => {
  if (!countries.langs().includes(locale.basename))
    countries.registerLocale(await loadCountryLocale(locale));
  return new Promise(resolve => resolve(void 0));
}

export const handleMomentJsLocale = async (locale: Locale, web: boolean = false): Promise<void> =>
{
  return importMomentJsLocale(locale)
    .then(ml => moment.locale(ml))
    .then(() => web ? loadCountries(locale) : void 0);
}
